import { MotionReveal } from '@/components/common/MotionReveal';
import { SectionTitle } from '@/components/common/SectionTitle';

const values = [
  { title: 'Kvalitet', text: 'Obim i kriterijume završetka dogovaramo pre početka rada.' },
  { title: 'Poverenje', text: 'O problemu razgovaramo otvoreno, bez ulepšavanja stanja.' },
  { title: 'Pouzdanost', text: 'Rok i odgovornost uvek imaju imenovanu osobu.' },
  { title: 'Transparentnost', text: 'Klijent ima pregled zadataka, odluka i rizika.' },
  { title: 'Profesionalnost', text: 'Dokumentacija i komunikacija ostaju uredne i upotrebljive.' }
];

export function CompanyValuesSection() {
  return (
    <section className="py-22 sm:py-28 lg:py-36">
      <div className="site-container grid gap-12 lg:grid-cols-[0.72fr_1.28fr] lg:gap-24">
        <MotionReveal>
          <SectionTitle eyebrow="Principi rada" title="Pravila koja važe na svakom projektu." />
        </MotionReveal>
        <div className="border-t border-border">
          {values.map((value, index) => (
            <MotionReveal key={value.title} delay={index * 0.035}>
              <article className="grid gap-2 border-b border-border py-5 sm:grid-cols-[0.42fr_0.58fr] sm:gap-8">
                <h3 className="font-semibold text-text-primary">{value.title}</h3>
                <p className="text-sm leading-6 text-text-secondary">{value.text}</p>
              </article>
            </MotionReveal>
          ))}
        </div>
      </div>
    </section>
  );
}

